import { useEffect, useState } from "react";

/** Тема Aikido (light/dark), сохраняется per-user в localStorage. */
export function useTheme(): [string, () => void] {
  const [theme, setTheme] = useState<string>(() => {
    try { return localStorage.getItem("aikido.theme") || "light"; } catch { return "light"; }
  });
  useEffect(() => { try { localStorage.setItem("aikido.theme", theme); } catch { /* */ } }, [theme]);
  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  return [theme, toggle];
}
